var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSocialApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 9 31 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.71 14.88c.86 0 1.93-.58 2.57-1.35.58-.7 1-1.68 1-2.66 0-.13 0-.26-.03-.37-.96.04-2.1.64-2.8 1.45a4.1 4.1 0 00-1.03 2.57c0 .15.02.3.04.34zM12.69 29.5c1.17 0 1.7-.79 3.15-.79 1.49 0 1.81.77 3.12.77 1.28 0 2.14-1.19 2.95-2.35.9-1.33 1.28-2.63 1.3-2.7a4.17 4.17 0 01-2.54-3.83c0-2.44 1.94-3.54 2.05-3.63a4.47 4.47 0 00-3.76-1.88c-1.44 0-2.61.87-3.35.87-.8 0-1.84-.82-3.09-.82-2.37 0-4.77 1.96-4.77 5.65 0 2.3.9 4.72 2 6.3.94 1.32 1.76 2.41 2.94 2.41z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-social--apple-675761a2f336e28390e12f5834a889d9.svg";
export { SvgIconSocialApple as Component };